function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "0,170.615 512,481.396 512,411.39 273.232,269.797 0,100.616 "
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg107Brunei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 512
  }), _ref2, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F0F0F0"
    },
    points: "512,411.384 512,341.387 0,30.604 0,100.616 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M304.224,237.452c0,26.633-21.591,48.224-48.224,48.224s-48.224-21.591-48.224-48.224   c0-8.304,2.099-16.118,5.796-22.94c-10.465,10.702-16.925,25.337-16.925,41.488c0,32.779,26.573,59.353,59.353,59.353   s59.353-26.574,59.353-59.353c0-16.15-6.46-30.786-16.925-41.488C302.125,221.334,304.224,229.148,304.224,237.452z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.87,
    y: 181.805,
    style: {
      fill: "#D80027"
    },
    width: 22.258,
    height: 111.282
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M293.095,204.066h-74.191c0,5.122,4.461,9.274,9.583,9.274h-0.309c0,5.122,4.153,9.274,9.274,9.274   c0,5.122,4.153,9.274,9.274,9.274h18.548c5.122,0,9.274-4.152,9.274-9.274c5.122,0,9.274-4.152,9.274-9.274h-0.308   C288.633,213.34,293.095,209.189,293.095,204.066z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.065,
    y: 300.511,
    style: {
      fill: "#D80027"
    },
    width: 103.869,
    height: 22.258
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.261,
    y: 307.935,
    style: {
      fill: "#D80027"
    },
    width: 44.514,
    height: 22.258
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.229,
    y: 307.935,
    style: {
      fill: "#D80027"
    },
    width: 44.514,
    height: 22.258
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg107Brunei);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };